import { NativeModules, Linking } from 'react-native';

export function getMacAudioCapture() {
  const capture = NativeModules.MacOSAudioCapture;
  if (!capture) throw new Error('Microphone support requires an updated macOS app. Please rebuild or update Gab AI.');
  return capture;
}

export const getRecordingPermissionsAsync = () => getMacAudioCapture().getMicrophonePermission();
export const requestRecordingPermissionsAsync = () => getMacAudioCapture().requestMicrophonePermission();
export const openMicrophoneSettings = () => Linking.openURL('x-apple.systempreferences:com.apple.preference.security?Privacy_Microphone');

let nextRecording = 0;
export class MacAudioRecording {
  constructor() {
    this.id = `dictate-${Date.now()}-${++nextRecording}`;
    this.audio = null;
    this.stopPromise = null;
  }
  startAsync() { return getMacAudioCapture().startRecording(this.id); }
  getStatusAsync() { return getMacAudioCapture().recordingStatus(this.id); }
  stopAndUnloadAsync() {
    this.stopPromise ||= getMacAudioCapture().stopRecording(this.id).then(audio => { this.audio = audio; });
    return this.stopPromise;
  }
  getURI() { return this.audio ? this.id : null; }
  getAudioData() { return this.audio; }
  discard() {
    this.audio = null;
    getMacAudioCapture().cancelRecording(this.id);
  }
}
